import { Answer } from 'model/Answer';
import { ProjectSubmit } from 'model/ProjectSubmit';
import { Resource } from 'model/Resource';
import { createSelector, Selector } from 'reselect';
import { SurveyState } from 'store/SurveyState';

import { createResourceContentSelector } from './resourceSelector';
import { selectAccessCode } from './navigationSelector';

export const selectSubmitResource: Selector<SurveyState, Resource<ProjectSubmit>> = (state) =>
  (state && state.submitResource) || Resource.void();

export const selectSubmit = createResourceContentSelector(selectSubmitResource);

export const selectAnswersFromLocalStorage = createSelector(selectAccessCode, (accessCode) => {
  const answersString = localStorage.getItem(accessCode);

  if (!answersString) return null;

  return JSON.parse(answersString);
});

export const selectAnswers = createSelector(
  selectSubmit,
  selectAnswersFromLocalStorage,
  (submit, storedAnswers) => {
    if (storedAnswers) {
      return storedAnswers.map((a: any) => new Answer(a));
    }

    return submit ? submit.getAnswers() : [];
  }
);

export const selectSurveyInitialAnswers = createSelector(selectAnswers, (answers) =>
  answers.reduce(
    (initialAnswers: { [key: string]: { option: any; answer: any }[] }, answer: Answer) => {
      const key = `id:${answer.getQuestion()}`;

      if (!initialAnswers[key]) {
        initialAnswers[key] = [];
      }

      initialAnswers[key].push({ option: answer.getOption(), answer: answer.getAnswer() });
      return initialAnswers;
    },
    {} as { [key: string]: { option: any; answer: any }[] }
  )
);
